"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immer_1 = require("immer");
const addMetaToState_1 = require("../helpers/addMetaToState");
const getSessionRegisteredEvent_1 = require("../helpers/getEvent/getSessionRegisteredEvent");
const getRegisterType_1 = require("../helpers/getRegisterType");
const getState_1 = require("../helpers/getState");
const entity_1 = require("../type/entity");
function addStateRegisterType(command, user, state) {
    const { timeStamp, waitList, joinWaitList } = command;
    state.registerType = getRegisterType_1.getRegisterType(command, user);
    state.waitListTimeStamp = waitList || joinWaitList ? timeStamp : null;
}
function setRegistrationFieldsInILTState(command, user, iltState) {
    const { creatorId: actorId, timeStamp, formResponse = {} } = command;
    const { userId } = user;
    if (actorId === userId) {
        iltState.lastAccessedOn = timeStamp;
    }
    iltState.deleted = false;
    iltState.updatedAt = timeStamp;
    addMetaToState_1.addMetaToState(iltState, formResponse);
}
function setRegistrationFieldsInILTSessionState(command, user, sessionState) {
    const { waitList, joinWaitList, timeStamp, learnerType = entity_1.ILTLearnerType.NONE } = command;
    if (sessionState.completionStatus === entity_1.CompletionStatus.NOT_ATTEMPTED || waitList || joinWaitList) {
        sessionState.startedOn = timeStamp;
    }
    sessionState.forceComplete = false;
    sessionState.deleted = false;
    sessionState.updatedAt = timeStamp;
    sessionState.learnerType = learnerType;
    addStateRegisterType(command, user, sessionState);
}
function registerToILTSessionState(command, user, sessionState) {
    const { contentId, sessionId, learnerType = entity_1.ILTLearnerType.NONE } = command;
    const events = [];
    setRegistrationFieldsInILTSessionState(command, user, sessionState);
    const sessionRegisteredEvent = getSessionRegisteredEvent_1.getSessionRegisteredEvent(command, user, contentId, [sessionId], learnerType, sessionState.registerType);
    // push session registration event
    events.push(sessionRegisteredEvent);
    return events;
}
function applyRegisterILTSessionCommand(command, user, states) {
    const { contentId, sessionId } = command;
    const { userId } = user;
    let events = [];
    const updatedStates = immer_1.produce(states, draftStates => {
        // current states
        const iltState = getState_1.getStateByContentIdUserId(draftStates, contentId, userId);
        const sessionState = getState_1.getStateByContentIdUserId(draftStates, sessionId, userId);
        if (iltState.completionStatus === entity_1.CompletionStatus.COMPLETE) {
            throw new Error('Cannot register another session on completed ILT');
        }
        // register to ILT session state
        const sessionStateEvents = registerToILTSessionState(command, user, sessionState);
        // update fields in ILT state
        setRegistrationFieldsInILTState(command, user, iltState);
        // update events
        events = events.concat(sessionStateEvents);
    });
    return { states: updatedStates, events, stateInteractions: [], enrolments: [] };
}
exports.applyRegisterILTSessionCommand = applyRegisterILTSessionCommand;
//# sourceMappingURL=applyRegisterILTSessionCommand.js.map